import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Field, reduxForm, clearSubmitErrors } from 'redux-form'

import { trackEvent, FormFieldset, FormLabel, CurrencyInput, Notification } from '@offerzen/pinata'

import aboutYou from '../../../assets/about-page.svg'
import { updateCandidate as reduxUpdateCandidate } from '../../redux/modules/candidate'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'
import { wantsWorkInSouthAfrica, wantsWorkOutsideSouthAfrica, wantsRemoteWork } from '../../selectors/salaryExpectations'
import { regionCode } from '../../selectors/currentUser'

import Card from '../../components/Card'
import PreferredSalaryZA from '../../components/PreferredSalaryZA'
import PreferredSalaryNL from '../../components/PreferredSalaryNL'
import { previousOnboardingUrl } from '../../helpers/onboardingSteps'
import CardFooterNav from '../../components/CardFooterNav/CardFooterNav'
import { validationConfigBuilder } from '../../../CandidateExperience/helpers/salaryExpectationHelpers'

import styles from './styles'

class SalaryExpectations extends Component {
  trackUser() {
    trackEvent('onboarding-salary-expectations-accessed')
  }

  componentDidMount() {
    this.props.updateProgress(56)
    this.props.candidate && this.trackUser()
  }

  updateProfile({ preferred_salary, current_salary, netherlands_preferred_annual_salary, netherlands_current_annual_salary }) {
    return this.props.updateCandidate(
      {
        preferred_salary,
        current_salary,
        netherlands_preferred_annual_salary,
        netherlands_current_annual_salary,
      },
      '/candidate/contact-number',
    )
  }

  render() {
    const isDefaultRegion = this.props.reduxRegioncode === 'eu' || !this.props.reduxRegioncode
    const validationConfig = validationConfigBuilder({
      regionCode: this.props.reduxRegioncode,
      wantsNonZA: this.props.wantsWorkOutsideSouthAfrica,
      wantsRemote: this.props.wantsRemoteWork,
      wantsZA: this.props.wantsWorkInSouthAfrica,
    })

    return (
      <Card title="Salary" imageUrl={aboutYou} width={550}>
        <form onSubmit={this.props.handleSubmit(this.updateProfile.bind(this))} onClick={() => this.props.clearFormErrors()}>
          <FormFieldset legend="What is your current salary?" className={styles.formFieldset}>
            <Choose>
              <When condition={isDefaultRegion}>
                <FormLabel label="Current gross annual salary" htmlFor="current-salary-nl" />

                <Field
                  name="netherlands_current_annual_salary"
                  id="current-salary-nl"
                  className={styles.currencyInput}
                  placeholder="Enter an annual salary"
                  component={CurrencyInput}
                  currency="euro"
                  theme="primary"
                />
              </When>
              <Otherwise>
                <div className={styles.tooltipWrapper}>
                  <FormLabel label="Current monthly salary (cost to company)" optional htmlFor="current-salary" />
                </div>

                <Field
                  name="current_salary"
                  id="current-salary"
                  className={styles.currencyInput}
                  placeholder="Enter a monthly salary"
                  helpText="We use this to give you expert salary advice, we will never share this with companies"
                  component={CurrencyInput}
                  theme="primary"
                />
              </Otherwise>
            </Choose>
          </FormFieldset>

          <FormFieldset legend="What would you like to earn in your next job?" className={styles.preferredSalary}>
            <p className={styles.text}>
              This is your salary before tax and other deductions. It should include relevent benefits and allowances (e.g. medical aid,
              retirement contribution, holiday allowance).
            </p>
            <p className={styles.text}>This amount applies to both remote and in-office work.</p>
            <PreferredSalaryNL validateField={validationConfig.EU.validateField} showField={validationConfig.EU.showField} />
            <PreferredSalaryZA validateField={validationConfig.ZA.validateField} showField={validationConfig.ZA.showField} />
          </FormFieldset>

          <If condition={this.props.error}>
            <Notification theme="error" className={styles.notification}>
              {this.props.error}
            </Notification>
          </If>
          <CardFooterNav
            navigateBack={() => this.props.history.push(previousOnboardingUrl(this.props.location.pathname))}
            loading={this.props.loading}
            className={styles.footer}
            theme="primary"
          />
        </form>
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  candidate: state.candidate,
  loading: state.candidate.loading,
  initialValues: {
    current_salary: state.candidate.current_salary,
    preferred_salary: state.candidate.preferred_salary,
    netherlands_preferred_annual_salary: state.candidate.netherlands_preferred_annual_salary,
    netherlands_current_annual_salary: state.candidate.netherlands_current_annual_salary,
  },
  wantsWorkInSouthAfrica: wantsWorkInSouthAfrica(state),
  wantsWorkOutsideSouthAfrica: wantsWorkOutsideSouthAfrica(state),
  wantsRemoteWork: wantsRemoteWork(state),
  reduxRegioncode: regionCode(state),
})

const mapDispatchToProps = dispatch => ({
  updateCandidate: (candidate, nextRoute) => dispatch(reduxUpdateCandidate(candidate, nextRoute)),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
  clearFormErrors: () => dispatch(clearSubmitErrors('salaryExpectations')),
})

SalaryExpectations.propTypes = {
  updateProgress: PropTypes.func.isRequired,
  updateCandidate: PropTypes.func.isRequired,
  candidate: PropTypes.shape({}).isRequired,
  reduxRegioncode: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  wantsRemoteWork: PropTypes.bool.isRequired,
  wantsWorkInSouthAfrica: PropTypes.bool.isRequired,
  wantsWorkOutsideSouthAfrica: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  loading: PropTypes.string,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    reduxForm({
      form: 'salaryExpectations',
    })(SalaryExpectations),
  ),
)
